<template>
  <div class="skeleton-wrapper" aria-hidden="true">
    <div class="skeleton-container">
      <!-- Avatar Skeleton -->
      <div class="skeleton-avatar skeleton-shimmer"></div>

      <!-- Title Skeleton -->
      <div class="skeleton-title skeleton-shimmer"></div>

      <!-- Description Skeleton -->
      <div class="skeleton-desc skeleton-shimmer"></div>

      <!-- Socials Skeleton -->
      <div class="skeleton-socials skeleton-shimmer"></div>

      <!-- Cards Grid Skeleton -->
      <div class="skeleton-grid">
        <div class="skeleton-column">
          <div class="skeleton-card skeleton-shimmer card-medium"></div>
          <div class="skeleton-card skeleton-shimmer card-large"></div>
          <div class="skeleton-card skeleton-shimmer card-medium"></div>
        </div>
        <div class="skeleton-column">
          <div class="skeleton-card skeleton-shimmer card-large"></div>
          <div class="skeleton-card skeleton-shimmer card-medium"></div>
          <div class="skeleton-card skeleton-shimmer card-medium"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HarmonyLoader'
}
</script>

<style scoped>
.skeleton-wrapper {
  min-height: 100vh;
  width: 100%;
  background: #f7f7f9;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 32px 16px 60px;
}

.skeleton-container {
  width: 100%;
  max-width: 580px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
}

.skeleton-shimmer {
  background: linear-gradient(90deg, #e8e8ea 0%, #f4f4f6 50%, #e8e8ea 100%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite ease-in-out;
  border-radius: 16px;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.skeleton-avatar {
  width: 120px;
  height: 120px;
  border-radius: 24px;
  margin-bottom: 18px;
}

.skeleton-title {
  width: 180px;
  height: 24px;
  border-radius: 12px;
  margin-bottom: 10px;
}

.skeleton-desc {
  width: 240px;
  height: 14px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.skeleton-socials {
  width: 260px;
  height: 48px;
  border-radius: 24px;
  margin-bottom: 20px;
}

.skeleton-grid {
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: center;
}

.skeleton-column {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  max-width: 275px;
}

.skeleton-card {
  width: 100%;
  border-radius: 20px;
}

.card-medium {
  height: 160px;
}

.card-large {
  height: 240px;
}

@media (max-width: 500px) {
  .skeleton-wrapper {
    padding: 20px 10px 40px;
  }

  .skeleton-avatar {
    width: 95px;
    height: 95px;
    border-radius: 20px;
    margin-bottom: 14px;
  }

  .skeleton-title {
    width: 140px;
    height: 20px;
  }

  .skeleton-desc {
    width: 200px;
    height: 12px;
    margin-bottom: 16px;
  }

  .skeleton-socials {
    width: 210px;
    height: 42px;
    border-radius: 20px;
    margin-bottom: 16px;
  }

  .skeleton-grid {
    gap: 8px;
  }

  .skeleton-column {
    gap: 8px;
  }

  .card-medium {
    height: 130px;
    border-radius: 16px;
  }

  .card-large {
    height: 200px;
    border-radius: 16px;
  }
}
</style>